import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const foldersUrl = `${SERVER_API}/folders`;

export const FOLDER_ENDPOINTS = {
  /**
   * Zip содержимого папки. Рекурсию в query не шлём: бэк для фронта её
   * не включал, файлы заявления лежат плоско в корне issue.folderId.
   */
  DOWNLOAD_ARCHIVE(folderId: number): IEndpointData {
    return {
      method: 'GET',
      url: `${foldersUrl}/${folderId}/downloads/archives`,
    };
  },
  // Контекст папки в path: file_id — UUID blob; операции меняют только FileToFolder / FileFolderLink.
  LINK_FILE(folderId: number, fileId: string): IEndpointData {
    return {
      method: 'POST',
      url: `${foldersUrl}/${folderId}/files/${fileId}/links`,
    };
  },
  UNLINK_FILE(folderId: number, fileId: string): IEndpointData {
    return {
      method: 'DELETE',
      url: `${foldersUrl}/${folderId}/files/${fileId}/links`,
    };
  },
  MOVE_FILE(sourceFolderId: number, fileId: string): IEndpointData {
    return {
      method: 'POST',
      url: `${foldersUrl}/${sourceFolderId}/files/${fileId}/move`,
    };
  },
  MOVE_FOLDER(folderId: number): IEndpointData {
    return {
      method: 'POST',
      url: `${foldersUrl}/${folderId}/move`,
    };
  },
  COPY_FOLDER(folderId: number): IEndpointData {
    return {
      method: 'POST',
      url: `${foldersUrl}/${folderId}/copy`,
    };
  },
};
